import styles from "./NavTopBarHeader.module.scss"
import { NavTopBarHeaderProps } from "./NavTopBarHeader.types"

export default function NavTopBarHeader(props: NavTopBarHeaderProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
